// BnBerry Action Centre card (EO-660). Two backend-driven states: RECOMMENDATION
// (eligible hotel, not yet opted in) and PENDING (hotel clicked Opt-in Now; the
// external HubSpot form can't be tracked, so the card persists at minimum priority
// as a nudge until the corridor opens). Copy is verbatim from the Figma
// (Action-Centre, node 2735:36185).
export const BNBERRY_CARD_STATE = {
  RECOMMENDATION: "RECOMMENDATION",
  PENDING: "PENDING",
};

// Action types sent to POST /recommendations/bnberry/action (matches the backend
// BnberryActionRequest.Action enum).
export const BNBERRY_ACTION = {
  OPT_IN: "OPT_IN",
  DISMISS: "DISMISS",
};

// Static HubSpot opt-in form. The backend may override this per-card via `formUrl`;
// this is the fallback so the CTA always has somewhere to open.
export const BNBERRY_FORM_URL =
  "https://share.hsforms.com/2yFs47xL5Sfa6lGFoAmZ8DAnq26j";

export const BNBERRY_COPY = {
  tag: "New Buyer Opportunity",
  recommendationHeadline: "Airbnb demand without the admin",
  recommendationDescription:
    "Tap into Airbnb and VRBO's global traveler base without extra workload.",
  pendingHeadline: "On your way to Airbnb demand",
  // Grant is finalising between three body options (see the requirement's card copy);
  // this is the first, kept here so it's a one-line change later.
  pendingBody:
    "Submitted your form? It's with BnBerry - there's nothing more to do. Didn't finish? Open the form below to complete your opt-in.",
  // Grey box: "Airbnb / VRBO via <BnBerry logo>" + a supporting line, shown in both states.
  partnerChannels: "Airbnb / VRBO",
  partnerVia: "via",
  partnerDescription:
    "Your listing, your rules. We handle every guest interaction so you don't have to.",
};

// Heap identifiers (kebab-case, per the project's tracking convention). Card-viewed
// is fired by useHeapCardViewed with card_type "bnberry".
export const BNBERRY_HEAP_ID = {
  optIn: "action-center-bnberry-optin",
  maybeLater: "action-center-bnberry-maybe-later",
  openForm: "action-center-bnberry-open-form",
  dismiss: "action-center-bnberry-dismiss",
};
